import React from 'react';
import TransactionHistoryPageContent from "../components/transactionHistoryPageContent";

const History = () =>{
    return(
        <TransactionHistoryPageContent/>
    );
}

export default History;